import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import FuerzaMiembrosSuperiores from '../components/FuerzaMiembrosSuperiores';

export default function CreateValoracionFuncionalPage() {
  const { idPaciente } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <FuerzaMiembrosSuperiores idPaciente={idPaciente} />
      </Container>
    </DashboardLayout>
  );
}
